<div class="toaster-container snackbar-shadow border-radius-8 margin-bottom overview-card no-background-color padding">
    <div class="flex-centered-container-vr warning-text">
        <div class="icon-wrapper flex-centered-container mat-icon-18" [class]="toastData.iconDetail.iconClass">
            <mat-icon>{{toastData.iconDetail.icon}}</mat-icon>
        </div>
        <div class="font-16 margin-8-left font-bold full-width">{{toastData.title}}</div>
    </div>
    <div class="font-14 description margin-8-bottom">
        {{ toastData.message }}
    </div>

    <div class="flex-centered-container-vr align-end">
        <button mat-flat-button color="accent" class="bg-accent-darker fg-white" (click)="sendFixEvent()">
            {{ toastData.button.label }}
        </button>
    </div>
</div>